import { useContext, useEffect, useState } from 'react';

import ArticlesContext from '../store/ArticlesProvider';
import AuthContext from '../store/AuthProvider';
import UserInfoContext from '../store/UserInfoProvider';

let deepEqual = require('deep-equal');

const SetBookmark = () => {
  const authCtx = useContext(AuthContext);
  const localId = authCtx.localId;
  const articlesCtx = useContext(ArticlesContext);
  const { articles } = articlesCtx;
  const userInfoCtx = useContext(UserInfoContext);
  const { userInfo, userArticles } = userInfoCtx;
  const [error, setError] = useState('');
  const [loadData, setLoadData] = useState(false);

  useEffect(() => {
    if (loadData) {
      setLoadData(false);
      fetch(`https://news-tag-node.vercel.app/api/users?usr=${localId}`)
        .then((res) => {
          if (!res.ok) {
            return res.json().then((data) => {
              throw new Error(data.message || 'Unknown error');
            });
          }
          return res.json();
        })
        .then((data) => {
          // Firebaseの構造はオブジェクトなので、最初のキーを使って配列のように扱う
          const keys = Object.keys(data);
          if (keys.length !== 0) {
            const userData = data[keys[0]];
            if (userData.articles !== undefined) {
              userInfoCtx.setUserArticles(userData.articles);
            }
          }
        })
        .catch((error) => setError('DB Error(loadData): ' + error.message));
    }
  }, [loadData]);

  useEffect(() => {
    if (userInfo && localId && userArticles !== null) {
      // Login後、Serverデータload済み + 差分あり → PUT
      if (!deepEqual(userArticles, articles)) {
        fetch(`https://news-tag-node.vercel.app/api/users?usr=${localId}&register=${userInfo}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ data: localId, articles }),
        })
          .then((res) => {
            if (!res.ok) {
              return res.json().then((data) => {
                throw new Error(data.message || 'Unknown error');
              });
            }
          })
          .catch((error) => setError('Database Error: ' + error.message));

        setTimeout(() => {
          setLoadData(true);
        }, 500);
      }
    } else if (!userInfo && localId) {
      // Login後、Serverデータload未完了 → GET
      fetch(`https://news-tag-node.vercel.app/api/users?usr=${localId}`)
        .then((res) => {
          const contentType = res.headers.get('content-type');
          console.log('GET from:', `https://news-tag-node.vercel.app/api/users?usr=${localId}`);
          if (!res.ok || !contentType?.includes('application/json')) {
            throw new Error('Invalid response from server');
          }
          return res.json();
        })
        .then((data) => {
          const keys = Object.keys(data);
          if (keys.length !== 0) {
            const userData = data[keys[0]];
            if (userData.articles !== undefined) {
              userData.articles.forEach((a) => articlesCtx.addArticles(a));
              userInfoCtx.setUserArticles(userData.articles);
            }
            userInfoCtx.setUserInfo(keys[0]);
          }
        })
        .catch((error) => setError('DB Error(articles): ' + error.message));
    }
  }, [articles]);

  return <>{error && console.log(`error:${error}`)}</>;
};

export default SetBookmark;
